<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{labelConstant.confirmFreeze}}</h4>
        <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
    </div>
    <form [formGroup]="sessionFreezeForm" (ngSubmit)="submitSessionFreezeForm()" novalidate>
        <mat-dialog-content class="">
            <p class="confirmation"> {{labelConstant.areYouSure}} <br /> {{labelConstant.freezeTheInstructor}}</p>
            <hr />
            <div *ngIf="hasParticipants == true">
                <p *ngIf="customerCount > 0">
                    There are {{customerCount}} member's whose passes have expired. Kindly extend the expiry date by
                    checking the customer list
                </p>
                <p *ngIf="customerCount <= 0">
                    There are no customers whose passes have expired.
                </p>
            </div>
            <div class="session-confirm-checkbox" *ngIf="hasParticipants == true">
                <div class="item">
                    <input type="checkbox" formControlName="addOnSessionon">
                    {{labelConstant.addOnSessionToPass}}
                </div>
                <div class="item last-item">
                    <div>
                        <input type="checkbox" formControlName="dateExtend">
                        {{labelConstant.extendExpiryDate}}
                    </div>
                    <div class="week-input">
                        <input type="number" name="week" id="week" min="0" formControlName="weeks"
                            oninput="this.value = this.value.replace(/^\s+|\D+/g, '')">
                        | <label for="week"> {{labelConstant.days}}
                        </label>
                    </div>
                    <div class="customer">
                        <span class="menu-icon" (click)="viewBookedSessionCustomers()">
                            <img src="../../../assets/icons/user-management.svg" alt=""
                                title="View Booked Session Customer(s)">
                        </span>
                    </div>
                </div>
            </div>
            <div class="note" *ngIf="hasParticipants == true">
                <p> <span class="confirmation">{{labelConstant.note}}</span>
                    {{labelConstant.someClinetHaveunlimitedPass}}</p>
            </div>
        </mat-dialog-content>
        <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
            <button class="btn btn-primary-outline" type="submit">{{labelConstant.yes}}</button>
            <button class="btn btn-primary" [mat-dialog-close]="false">{{labelConstant.no}}</button>
        </div>
    </form>
</div>